import FormItem from "../../../../components/FormItem";
import React, { useState, useEffect } from "react";
import { useSelector } from "inbooma-api";
import { in_array } from "../../../../../utils/Helper";

const getValidDates = (props) => {
  const {
    t,
    Biscuit,
    visualInspectionsActions,
    dispatch,
    moment,
    onDateChangedHandler,
    item,
    setVisualInspections,
    visualInspections,
  } = props;
  const clientId = Number(Biscuit.get("user.client_id"));
  const [timeUnit, setTimeUnit] = useState(null);
  const [unit, setUnit] = useState(null);
  const [weekdayUnit, setWeekdayUnit] = useState(null);
  const [until, setUntil] = useState(null);
  const [getValidDatesPending, setGetValidDatesPending] = useState(false);
  const _getValidDates = useSelector(
    (state) => state["visual_inspections_data"].getValidVisualInspectionDates,
  );

  const onChangeTimeUnit = (e) => {
    switch (e.target.value) {
      case "every_a":
    }
    setTimeUnit(e.target.value);
  };
  const onChangeUnit = (e) => {
    setUnit(e.target.value);
  };
  const onChangeWeekDayUnit = (e) => {
    setWeekdayUnit(e.target.value);
  };
  const onDChangedHandler = (e) => {
    setUntil(e);
  };
  useEffect(() => {
    if (until !== null && !getValidDatesPending) {
      let data = {
        client_id: clientId,
        from: moment().format("YYYY-MM-DD HH:mm"),
        to: moment(until).format("YYYY-MM-DD HH:mm"),
        interval: unit,
      };
      if (in_array(timeUnit, ["every_a", "every_c", "every_d"])) {
        data["intervalUnit"] =
          timeUnit === "every_a" ? "day" : timeUnit === "every_c" ? "week" : "month";
      } else {
        data["day"] = weekdayUnit;
      }
      dispatch(
        visualInspectionsActions.getValidVisualInspectionDates({
          token: Biscuit.get("token"),
          data: data,
        }),
      );
      setGetValidDatesPending(true);
    }
  }, [until]);

  useEffect(() => {
    if (_getValidDates.success === "" || !getValidDatesPending) {
      return;
    }
    if (_getValidDates.success === true) {
      let vis = [];
      _getValidDates.data.map((dat) => {
        vis.push({
          date: dat,
          client_id: clientId,
        });
      });
      setVisualInspections(vis);
    }
    setGetValidDatesPending(false);
  }, [_getValidDates]);
  let text = "";
  return (
    <>
      <div
        className="row"
        style={{
          width: "100%",
          paddingRight: ".9375rem",
          paddingLeft: ".9375rem",
          marginBottom: "20px",
        }}
      >
        <span className="medium-2 visual-inspection-span visual-inspection-title">
          {t("Show available dates for every") + " "}
        </span>
        <input
          className="medium-1"
          id="unit"
          style={{ maxWidth: "60px", float: "left" }}
          type="number"
          onChange={(e) => onChangeUnit(e)}
          value={unit}
        />
        <span className="medium-1 visual-inspection-span visual-inspection-point">.</span>
        <select
          className="medium-1 visual-inspection-weekday-select"
          id="timeUnit"
          onChange={(e) => onChangeTimeUnit(e)}
          value={timeUnit}
        >
          <option value={null}>{t("switch")}</option>
          <option value="every_a">{t("daytime")}</option>
          <option value="every_b">{t("weekday")}</option>
          <option value="every_c">{t("week")}</option>
          <option value="every_d">{t("month")}</option>
        </select>
        {timeUnit !== null && (
          <>
            {timeUnit === "every_b" && (
              <>
                <select
                  className="medium-1 visual-inspection-weekday-select"
                  id="weekdayUnits"
                  onChange={(e) => onChangeWeekDayUnit(e)}
                  value={weekdayUnit}
                >
                  <option value={null}>{t("switch")}</option>
                  <option value="monday">{t("monday")}</option>
                  <option value="tuesday">{t("tuesday")}</option>
                  <option value="wednesday">{t("wednesday")}</option>
                  <option value="thursday">{t("thursday")}</option>
                  <option value="friday">{t("friday")}</option>
                  <option value="saturday">{t("saturday")}</option>
                  <option value="sunday">{t("sunday")}</option>
                </select>
              </>
            )}
            {unit !== null &&
              (timeUnit !== "every_b" || (timeUnit === "every_b" && weekdayUnit !== null)) && (
                <>
                  <span className="medium-1 visual-inspection-span visual-inspection-to">
                    {" "}
                    {t("valid_to")}{" "}
                  </span>
                  <FormItem
                    name="to"
                    type="datePicker"
                    placeholder=""
                    selected={until}
                    dateFormat="dd.MM.y"
                    datePickerClass="noBorders-noBackground"
                    onChangeHandler={onDChangedHandler}
                    mediumWidth={2}
                    smallWidth={12}
                    extraTopClasses=""
                  />
                  {!getValidDatesPending && (
                    <>
                      {_getValidDates.data.length > 0 ? (
                        <>
                          <span id="validDate" className="medium-12">
                            {_getValidDates.data.map((da) => {
                              if (text === "") {
                                text = moment(da).format("DD.MM.YYYY");
                              } else {
                                text += ", " + moment(da).format("DD.MM.YYYY");
                              }
                            })}
                            {t("found dates") + ": " + text}
                          </span>
                        </>
                      ) : (
                        <>
                          {_getValidDates.success !== "" && (
                            <span className="medium-1 visual-inspection-span">
                              {t("no valid dates found")}
                            </span>
                          )}
                        </>
                      )}
                    </>
                  )}
                  {getValidDatesPending && (
                    <span>
                      <img
                        alt="RollingLoader"
                        className="rollingLoader"
                        src={"assets/img/rolling_loader.svg"}
                      />{" "}
                    </span>
                  )}
                </>
              )}
          </>
        )}
      </div>
    </>
  );
};
export default getValidDates;
